<template>
  <div class="tab-pane active">
    <div class="responsive-table">
      <div class="loading min-h-300" v-if="loading">
        <LoadingAnim />
      </div>
      <table v-else-if="campaigns.length > 0" class="table">
        <thead class="">
          <tr>
            <th scope="col">{{ $tc('app.name', 1) }}</th>
            <!-- Data -->
            <th scope="col">{{ $t('app.created_at') }}</th>
            <!-- Tipo -->
            <th scope="col">{{ $t('app.sent_at') }}</th>
            <!-- Remetente -->
            <th scope="col">Status</th>
            <!-- Destinatario -->
            <th scope="col">{{ $tc('app.message', 2) }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="campaign in campaigns"
            :key="campaign.id"
          >
            <td data-label="Data">
              <div>
                {{ campaign.name ? campaign.name : campaign.interface }}
              </div>
            </td>
            <td data-label="Tipo">
              {{ campaign.created_at | formatDate24 }}
            </td>
            <td data-label="Remetente">{{ campaign.scheduled_at | formatDate24 }}</td>
            <td data-label="Status">
              <span
                v-if="campaign.status == 'accepted'"
                class="badge badge-light"
                >{{ $tc('generic-str.status.lbl-pending', 1) }}</span
              >
              <!-- Pendente -->
              <span
                v-else-if="campaign.status == 'queued'"
                class="badge badge-secondary"
                >{{ $t('generic-str.status.lbl-queue') }}</span
              >
              <!-- Em Fila -->
              <span
                v-else-if="campaign.status == 'sending'"
                class="badge badge-accent"
                >{{ $t('generic-str.status.lbl-sending') }}</span
              >
              <!-- Enviando -->
              <span
                v-else-if="campaign.status == 'sent'"
                class="badge badge-info"
                >{{ $t('generic-str.status.lbl-sent') }}</span
              >
              <!-- Enviado -->
              <span
                v-else-if="campaign.status == 'failed'"
                class="badge badge-danger"
                v-tooltip.top="
                  `${$t('sms.infos.filters.status.lbl-error')} ${
                    campaign.error_code
                  }: ${campaign.error_message}`
                "
                >{{ $tc('app.failed') }}</span
              >
              <!-- Falha -->
              <span
                v-else-if="campaign.status == 'delivered'"
                class="badge badge-success"
                >{{ $tc('app.delivered') }}</span
              >
              <!-- Entregue -->
              <span
                v-else-if="campaign.status == 'undelivered'"
                class="badge badge-dark"
                v-tooltip.top="
                  $t('generic-str.status.lbl-error') +
                  ` ${campaign.error_code}: ${campaign.error_message}`
                "
                >{{ $t('generic-str.status.lbl-unavailable') }}</span
              >
              <!-- Indisponivel -->
              <span
                v-else-if="campaign.status == 'received'"
                class="badge badge-success"
                >{{ $tc('generic-str.status.lbl-response', 1) }}</span
              >
              <!-- Resposta -->
            </td>
            <td
              data-label="Mensagens"
              class="max-200"
            >
              <router-link :to="`/whatsapp/jv/reports/history/${campaign.id}`" class="text-primary link-out-side">
                <span>Ver Mensagens</span> <span class="material-symbols-outlined link-message">arrow_outward</span>
              </router-link>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="row">
        <pagination :lastPage="pages" @change="fetch" />
      </div>
      <div class="no-item-list" v-if="campaigns.length == 0 && !loading">
        <span class="material-symbols-outlined"> campaign </span>
        <span>Nenhuma campanha enviada</span>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import WhatsService from '@/services/whatsapp.service';
import Pagination from '@/components/Pagination.vue';
import LoadingAnim from '@/components/rebranding/animLottie/Loading.vue';
import axios from '@/plugins/axios';

const webApi = axios();

export default {
  name: 'SmsHistoryTab',
  components: {
    // PageHeader,
    Pagination,
    LoadingAnim,
  },
  props: {
    filters: {
      type: Object,
    },
    startDate: {
      type: String,
    },
    endDate: {
      type: String,
    },
  },
  data() {
    return {
      loading: true,
      options: {
        timePicker: false,
        autoApply: true,
        className: 'form-control',
        maxSpan: {
          days: 31,
        },
        locale: {
          format: 'DD/MM/YYYY',
          daysOfWeek: ['Do', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sa'],
          monthNames: [
            'Jan',
            'Fev',
            'Mar',
            'Abr',
            'Mai',
            'Jun',
            'Jul',
            'Ago',
            'Set',
            'Otu',
            'Nov',
            'Dez',
          ],
        },
      },
      fetched: true,
      campaigns: [],
      form: {
        id: '',
        status: '',
        from: '',
        to: '',
        scheduled_at: {
          gte: '',
          lte: '',
        },
        order_by: ['scheduled_at', 'desc'],
        page: 1,
      },
      pages: 1,
      exporting: false,
    };
  },
  created() {
    this.fetch(1);
  },
  methods: {
    fetch(page) {
      this.loading = true;
      console.log(this.filters);
      console.log('FETCH WHATSAPP');

      this.filters.page = page - 1;
      this.fetched = false;

      // query=x&query=y&page=1

      const accounId = this.$store.state.account.id;
      const form = this.form;

      const params = [];

      if (form.id) {
        params.push(`id;eq;'${form.id}'`);
      } else {
        if (this.filters.status.length > 0) {
          const status = this.filters.status.map((value) => value.toUpperCase());
          // params.push(`status;in;'${status}'`);
          params.push(`status;in;'${status.join('\':\'')}'`);
        }

        if (this.filters.to) {
          // Contactmos o cliente
          params.push('message_origin;ne;\'CLIENT\'');
          params.push(`client_number;eq;'${encodeURIComponent(this.filters.to)}'`);
        } else if (form.sender) {
          // Cliente nos responde
          params.push('message_origin;eq;\'CLIENT\'');
          params.push(`client_number;eq;'${encodeURIComponent(this.filters.from)}'`);
        }

        if (this.startDate) {
          params.push(`timestamp;gte;'${new Date(this.startDate).toISOString()}'`);
        }

        if (this.endDate) {
          params.push(`timestamp;lte;'${new Date(this.endDate).toISOString()}'`);
        }

        if (form.customer_ids && form.customer_ids.length) {
          params.push(`whatsapp_business.account_id;in;'${form.customer_ids.join('\',\'')}'`);
        } else {
          params.push(`whatsapp_business.account_id;eq;'${accounId}'`);
        }
      }

      const orderBy = 'orderBy=timestamp;desc';

      WhatsService.getNewCampaigns({
        filter: {
          ...this.filters,
          scheduled_at: {
            gte: this.startDate,
            lt: this.endDate,
          },
        },
        page,
      }).then(
        (response) => {
          console.log('response.data', response.data);
          this.loading = false;
          this.campaigns = response.data;
          this.pages = response.last_page;
          console.log('FETCH WHATSAPP', response);
        },
        (error) => {
          this.content = error;
          this.loading = false;
          this.$toast.show({
            title: 'Erro',
            content: 'Erro interno, por favor tente novamente mais tarde.',
            type: 'danger',
          });
          console.log(JSON.stringify(error.response.data));
        },
      );
    },
    exportData(format) {
      this.loading = true;
      console.log(this.filters);
      console.log('FETCH WHATSAPP');

      // this.filters.page = page - 1;
      this.fetched = false;

      // query=x&query=y&page=1

      const accounId = this.$store.state.account.id;
      const form = this.form;

      const params = [];

      if (this.$route.params.id) {
        params.push(`campaign_ext_id;eq;'${encodeURIComponent(this.$route.params.id)}'`);
      } else if (this.filters.campaign) {
        params.push(`campaign_ext_id;eq;'${encodeURIComponent(this.filters.campaign)}'`);
      }

      if (form.id) {
        params.push(`id;eq;'${form.id}'`);
      } else {
        if (this.filters.status.length > 0) {
          const status = this.filters.status.map((value) => value.toUpperCase());
          params.push(`status;in;'${status}'`);
        }

        if (this.filters.to) {
          // Contactmos o cliente
          params.push('message_origin;ne;\'CLIENT\'');
          params.push(`client_number;eq;'${encodeURIComponent(this.filters.to)}'`);
        } else if (form.sender) {
          // Cliente nos responde
          params.push('message_origin;eq;\'CLIENT\'');
          params.push(`client_number;eq;'${encodeURIComponent(this.filters.from)}'`);
        }

        if (this.filters.gte) {
          params.push(`timestamp;gte;'${new Date(this.filters.gte).toISOString()}'`);
        }

        if (this.filters.lte) {
          params.push(`timestamp;lte;'${new Date(this.filters.lte).toISOString()}'`);
        }

        if (form.customer_ids && form.customer_ids.length) {
          params.push(`whatsapp_business.account_id;in;'${form.customer_ids.join('\',\'')}'`);
        } else {
          params.push(`whatsapp_business.account_id;eq;'${accounId}'`);
        }
      }

      const orderBy = 'orderBy=timestamp;desc';

      webApi.post(`/whatsapp/new/report/generate?query[]=${params.join('&query[]=')}&format=${format}&page=${this.filters.page}&${orderBy}`, {
        from: this.filters.gte,
        to: this.filters.lte,
        format,
      }).then((response) => {
        console.log('Export');
        console.log(response);
        this.loading = false;
        this.$router.push('/whatsapp/jv/reports/exports');
      }, (error) => {
        this.loading = false;
        this.content = error;
        this.$toast.show({
          title: 'Erro',
          content: 'Erro interno, por favor tente novamente mais tarde ou contact o suporte para ajuda.',
          type: 'error',
        });
      });
    },
    exportMessages() {
      this.exporting = true;
      WhatsService.exportSms({
        filter: {
          id: this.form.id,
          from: this.form.from,
          to: this.form.to,
          status: this.form.status,
          sent_at: {
            from: this.beginDate,
            to: this.endDate,
          },
        },
      })
        .then(
          () => {
            this.$toast.show({
              title: this.$t('generic-str.success'),
              content: this.$t('warnings.toast.report'),
              type: 'success',
            });
            this.$router.push('/sms/exports');
          },
          (error) => {
            this.$toast.show({
              title: this.$t('sms.infos.filters.status.lbl-error'),
              content: error.response.data.message,
              type: 'danger',
            });
          },
        )
        .finally(() => {
          this.exporting = false;
        });
    },
  },
};
</script>

<style scoped lang="scss">
.btn-search-id {
  height: 35px;
}
.btn-export {
  margin-left: 1px;
  padding: 8px 20px !important;
}
.m-top-10 {
  margin-top: 10px;
}

/* Rebranding */
.rebranding .card.borderless {
  box-shadow: unset !important;
}

.form-group {
  .icon_btn {
    display: flex;
    align-items: center;
    background-color: #fff;
    border: 1px solid var(--form-border);
    border-left-color: transparent;
    border-radius: 0.25rem;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;

    span {
      color: var(--gray-font-color);
    }
  }
}
.darkmode .form-group .icon_btn {
  background-color: var(--form-input);
  border-color: var(--form-border);
  border-left-color: transparent;
}
.icon-success {
  color: #6eda2c;
}
.icon-failed {
  color: #ff0000;
}
table {
  border-collapse: separate !important;
  border-spacing: 0 10px !important;
  &.busy {
    opacity: 0.55;
  }
}
.table th,
.table thead th {
  border: none;
}

td,
th {
  vertical-align: middle;
}
tr td {
  padding: 18px;
}
td {
  border: 1px solid #e5e5e5;
  border-style: solid none;
}

td:first-child {
  border-left-style: solid;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}

td:last-child {
  border-right-style: solid;
  border-bottom-right-radius: 8px;
  border-top-right-radius: 8px;
}
.text-primary {
  color: var(--clr-yup-purple) !important;
}
.link-out-side {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;

}
.link-message {
  margin-left: 3px;
  font-size: 18px;
}
.no-item-list {
  padding-top: 60px;
  width: 30%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #c7c7c7;
}
.no-item-list .material-symbols-outlined {
  font-size: 90px;
  margin-bottom: 10px;
}
</style>
